@if ((isSeePriceInCart || isClearance) && pricingInfo) {
    <s class="was-text"
       aria-label="Was {{pricingInfo.listPrice | currency }}">
        @if (isSeePriceInCart || pricingInfo.minlistprice) {
            <span>
                <span>{{pricingInfo.minlistprice | currency }}</span>
                @if (pricingInfo.maxlistprice !== pricingInfo.minlistprice) {
                    <span> - {{pricingInfo.maxlistprice | currency }}</span>
                }
            </span>*
        }
        @if (!isSeePriceInCart && !pricingInfo.minlistprice) {
            <span>{{pricingInfo.listPrice | currency }}</span>*
        }
    </s>
}
